import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../store';
import { selectAuthUser } from '../store/slices/auth/auth.selector';

export const useSettingsNavigation = () => {
  const navigate = useNavigate();
  const user = useAppSelector(selectAuthUser);
  const orgSlug = user?.orgSlug ?? 'org';

  const base = () => `/${orgSlug}/settings`;

  return {
    orgSlug,

    /** /{orgSlug}/settings */
    toSettings: (replace = false) =>
      navigate(`${base()}`, { replace }),

    /** /{orgSlug}/settings/manage-users */
    toManageUsers: (replace = false) =>
      navigate(`${base()}/manage-users`, { replace }),

    /** /{orgSlug}/settings/organization */
    toOrganizationSettings: (replace = false) =>
      navigate(`${base()}/organization`, { replace }),

    /** Build raw URL strings (for breadcrumbs / Link to= props) */
    buildSettingsUrl: () => `${base()}`,
    buildManageUsersUrl: () => `${base()}/users`,
    buildOrganizationSettingsUrl: () => `${base()}/organization`,
  };
};